import makeFormGroup from "./utils/makeFormGroup";
import ButtonSwitch from "./ButtonSwitch";
import CategoriesInput from "./CategoriesInput";
import Checkbox from "./Checkbox";
import CheckboxFormGroup from "./CheckboxFormGroup";
import Date from "./Date";
import DateRange from "./DateRange";
import DateSelect from "./DateSelect";
import DateTime from "./DateTime";
import ValueToggle from "./ValueToggle";
import DeleteRowButton from "./DeleteRowButton";
import FormattableTextArea from "./FormattableTextArea";
import FormGroup from "./FormGroup";
import ImageAttachment from "./ImageAttachment";
import Input from "./Input";
import LocaleSelect from "./LocaleSelect";
import Location from "./Location";
import Money from "./Money";
import MultipleCheckbox from "./MultipleCheckbox";
import MultipleDate from "./MultipleDate";
import MultipleInput from "./MultipleInput";
import MultipleRadio from "./MultipleRadio";
import MultipleTime from "./MultipleTime";
import NumberLimitFormGroup from "./NumberLimitFormGroup";
import NumberSwitch from "./NumberSwitch";
import OrderedProductOrderField from "./OrderedProductOrderField";
import OrderedProductOrderFieldFormGroup from "./OrderedProductOrderFieldFormGroup";
import OrderedProductPricelistItemFormGroup from "./OrderedProductPricelistItemFormGroup";
import ProductsSelect from "./ProductsSelect";
import Radio from "./Radio";
import SaleWindowRuleFormGroup from "./SaleWindowRuleFormGroup";
import Select from "./Select";
import SelectLimitFormGroup from "./SelectLimitFormGroup";
import SeparateDateRange from "./SeparateDateRange";
import Star from "./Star";
import TagsInput from "./TagsInput";
import TextArea from "./TextArea";
import Time from "./Time";
import TimeDuration from "./TimeDuration";
import TypeaheadInput from "./TypeaheadInput";
import UsebyDateRangeFormGroup from "./UsebyDateRangeFormGroup";

const addProps = (prop, { errors }) => ({
  name: prop,
  error: errors && errors[prop],
});

const ButtonSwitchFormGroup = makeFormGroup(ButtonSwitch);
const CategoriesInputFormGroup = makeFormGroup(CategoriesInput);
const DateFormGroup = makeFormGroup(Date);
const DateRangeFormGroup = makeFormGroup(DateRange);
const DateSelectFormGroup = makeFormGroup(DateSelect);
const DateTimeFormGroup = makeFormGroup(DateTime);
const ValueToggleFormGroup = makeFormGroup(ValueToggle);
const FormattableTextAreaFormGroup = makeFormGroup(FormattableTextArea);
const ImageAttachmentFormGroup = makeFormGroup(ImageAttachment);
const InputFormGroup = makeFormGroup(Input);
const LocaleSelectFormGroup = makeFormGroup(LocaleSelect);
const LocationFormGroup = makeFormGroup(Location);
const MoneyFormGroup = makeFormGroup(Money);
const MultipleCheckboxFormGroup = makeFormGroup(MultipleCheckbox, {
  multipleFields: true,
});
const MultipleDateFormGroup = makeFormGroup(MultipleDate);
const MultipleInputFormGroup = makeFormGroup(MultipleInput);
const MultipleRadioFormGroup = makeFormGroup(MultipleRadio, {
  multipleFields: true,
});
const MultipleTimeFormGroup = makeFormGroup(MultipleTime);
const NumberSwitchFormGroup = makeFormGroup(NumberSwitch);
const ProductsSelectFormGroup = makeFormGroup(ProductsSelect);
const RadioFormGroup = makeFormGroup(Radio);
const SelectFormGroup = makeFormGroup(Select);
const SeparateDateRangeFormGroup = makeFormGroup(SeparateDateRange);
const StarFormGroup = makeFormGroup(Star);
const TagsInputFormGroup = makeFormGroup(TagsInput);
const TextAreaFormGroup = makeFormGroup(TextArea);
const TimeDurationFormGroup = makeFormGroup(TimeDuration);
const TimeFormGroup = makeFormGroup(Time);
const TypeaheadInputFormGroup = makeFormGroup(TypeaheadInput);

export {
  addProps,
  ButtonSwitch,
  ButtonSwitchFormGroup,
  CategoriesInputFormGroup,
  Checkbox,
  CheckboxFormGroup,
  Date,
  DateFormGroup,
  DateRange,
  DateRangeFormGroup,
  DateSelect,
  DateSelectFormGroup,
  DateTime,
  DateTimeFormGroup,
  ValueToggle,
  ValueToggleFormGroup,
  DeleteRowButton,
  FormattableTextArea,
  FormattableTextAreaFormGroup,
  FormGroup,
  ImageAttachment,
  ImageAttachmentFormGroup,
  Input,
  InputFormGroup,
  LocaleSelect,
  LocaleSelectFormGroup,
  Location,
  LocationFormGroup,
  Money,
  MoneyFormGroup,
  MultipleCheckbox,
  MultipleCheckboxFormGroup,
  MultipleDate,
  MultipleDateFormGroup,
  MultipleInput,
  MultipleInputFormGroup,
  MultipleRadio,
  MultipleRadioFormGroup,
  MultipleTime,
  MultipleTimeFormGroup,
  NumberLimitFormGroup,
  NumberSwitch,
  NumberSwitchFormGroup,
  OrderedProductOrderField,
  OrderedProductOrderFieldFormGroup,
  OrderedProductPricelistItemFormGroup,
  ProductsSelect,
  ProductsSelectFormGroup,
  Radio,
  RadioFormGroup,
  SaleWindowRuleFormGroup,
  Select,
  SelectFormGroup,
  SelectLimitFormGroup,
  SeparateDateRange,
  SeparateDateRangeFormGroup,
  Star,
  StarFormGroup,
  TagsInput,
  TagsInputFormGroup,
  TextArea,
  TextAreaFormGroup,
  Time,
  TimeDuration,
  TimeDurationFormGroup,
  TimeFormGroup,
  TypeaheadInput,
  TypeaheadInputFormGroup,
  UsebyDateRangeFormGroup,
};



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/index.js